import React from 'react';

const TextTitle = (props) => {
    return (
        <div style={{ fontSize: 20 }}>
            {props.title}
        </div>
    );
}

export default TextTitle;